import React, { useEffect, useState } from "react"
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"
import { TableTrajets } from "./TableTrajets"
import { muiThemeStyle } from "../Theme/Theme"
import { fetchAltimaId, sessionStorageAction } from "../utils"
import Store from "../SessionStorage"
import { getImageAssetUrl } from "Utilities/url"
import Loader from "../components/Loader"
import { getUserInfo, getUserInfoContract } from "Services/Dashboard"

const Trajets = ({ accessToken }) => {
  const [loading, setLoading] = useState(true)
  const [personId, setPersonId] = useState(null)
  const [policyId, setPolicyId] = useState(null)
  const [productId, setProductId] = useState(null)

  useEffect(() => {
    getUserInfo(accessToken)
      .then(userInfo => {
        return getUserInfoContract(accessToken, userInfo.email)
          .then(userInfoContract => {
            const clientId = userInfoContract.clientID
            const policyId = userInfoContract.contractID
            const productId = userInfoContract.codeProduit
            setPolicyId(policyId)
            setProductId(productId)
            return fetchAltimaId(clientId).then(personId => setPersonId(personId))
          }).then(() => setLoading(false))
      }).catch(() => logout())
  });

    const logout = () => {
      window.sessionStorage.removeItem(sessionStorageAction.dashboard.accessToken);
      window.location.href = '/particuliers/auto/assurance-auto-usage/espace-client';
    };

    return (
      <div>
        <div
          className="admin-dashboard-header"
          style={{ backgroundImage: `url(${getImageAssetUrl("header-minute.jpeg")}` }}
        >
          <div className="admin-dashboard-header-blur" />
          <span className="admin-dashboard-header-title">Votre espace personnel</span>
          <div className="admin-dashboard-header-button-container">
            <a
              className="admin-dashboard-deconnection admin-dashboard-header-button"
              href={`/particuliers/auto/assurance-auto-usage/espace-client?token=${Store.get(sessionStorageAction.dashboard.accessToken)}`}
              title="Espace perso"
            >
              <i className="material-icons menu">arrow_back</i>
              <span>Retour</span>
            </a>
            <a
              className="admin-dashboard-deconnection admin-dashboard-header-button"
              onClick={logout}
              title="Déconnexion"
            >
              <span>Déconnexion</span>
              <i className="material-icons">power_settings_new</i>
            </a>
          </div>
        </div>
        <div className="main-page-header">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <h1>Déclarer mes trajets</h1>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ width: '90%', textAlign: 'center' }}>
            <MuiThemeProvider muiTheme={muiThemeStyle}>
              {loading ? <Loader tip={"Chargement en cours..."} /> : <TableTrajets personId={personId} policyId={policyId} productId={productId} />}
            </MuiThemeProvider>
          </div>
        </div>
      </div>
    )
}

export default Trajets
